export default {
  namespaced: true,
  state: {
    imgWidth: 1200,
    imgHeight: 1800
  }
}
